// AMBIENTE DEV desarrollo
// ng serve --configuration=dev
// ng build --configuration=dev
export const environment = {
  production: true,
  Ambiente: 'fliebencaptest',
  // para mi fiel /////
  APP_ID: '',
  APP_SECRET: '',
  URL_MIFIEL: '',
  // para mi fiel /////
  URL_SERVICIOS: 'https://fargatetestapp.fliebencapital.com/api/v1',
 // URL_SERVICIOS_ALT: 'https://fargatetestapp.fliebencapital.com/api/v1',  https://testfliebencap.factoringdev.com/api/v1
  CLIENTE: 'FACTORGFCGLOBAL',
  // firebase del proyecto de flieben
  firebase: {
    apiKey: "AIzaSyAH-0mX8StH3WJQSSSGs8vEDJp7gZDHctw",
    authDomain: "fliebencapitaltest.firebaseapp.com",
    projectId: "fliebencapitaltest",
    storageBucket: "fliebencapitaltest.appspot.com",
    messagingSenderId: "640075615337",
    appId: "1:640075615337:web:8cf8d8d7915f10b3ab66f8",
    measurementId: "G-E6EVNHXYJZ"
  },
  AWS: {
    accessKeyId: "",
    secretAccessKey: "",
    region: "",
    folder: "",
    bucketNomina: "",
  },

};
